import React, { useState } from 'react'
import dayjs from 'dayjs'
import Calendar from 'library/molecules/Calendar'
import { H4, Text } from 'library/atoms/Typography'
import { Form, Formik } from 'formik'
import Button from 'library/atoms/Button'
import Modal from 'shared/library/molecules/Modal'
import Flex from 'shared/library/atoms/Flex'
import Icon from 'shared/library/atoms/Icon'
import {
  StyleGuideMain,
  StyleGuideIdProps
} from 'shared/library/pages/StyleGuide'

const ModalContainer = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <Formik
      initialValues={{ calendar: undefined }}
      onSubmit={() => alert('submitted')}
    >
      {({ values }) => (
        <>
          <Flex flexDirection="column">
            <Button onClick={() => setIsOpen(true)}>Open Calendar</Button>
            <p>{dayjs(values.calendar).format('DD/MM/YYYY')}</p>
          </Flex>
          <Modal isOpen={isOpen}>
            <Flex p={3} alignItems="center" justifyContent="space-between">
              <H4>Select a day</H4>
              <Button variant="icon" onClick={() => setIsOpen(false)}>
                <Icon name="close" color="grey" />
              </Button>
            </Flex>
            <Formik
              initialValues={{ calendar: undefined }}
              onSubmit={() => alert('submitted')}
            >
              {() => (
                <Calendar
                  name="calendar"
                  availableDays={dayjs().add(2, 'days').toDate()}
                  onDateChange={() => setIsOpen(false)}
                />
              )}
            </Formik>
          </Modal>
        </>
      )}
    </Formik>
  )
}

const PROPS = {
  Description: () => (
    <>
      <Text>
        This is a date picker to provide a simple way to select a value from the
        calendar form. This has Formik baked into it for ease of use.
      </Text>
    </>
  ),
  examples: [
    {
      title: 'Calendar - using a hidden input',
      code: `<Formik initialValues={{calendar: undefined}} onSubmit={()=> {}}>
  {({ values }) => (
    <Form style={{ width: '100%', maxWidth: 480 }}>
      <Calendar
        name="calendar"
        availableDays={dayjs().add(2, 'days').toDate()}
      />
      <p>{dayjs(values.calendar).format('DD/MM/YYYY')}</p>
    </Form>    
  )}
</Formik>`,
      scope: { Calendar, Formik, Form, dayjs }
    },
    {
      title: 'Calendar - input field',
      code: `<Formik initialValues={{date: undefined}} onSubmit={()=> {}}>
  {({ values }) => (
    <Form>
      <Calendar
        showInput
        name="date"
        availableDays={dayjs().add(2, 'days').toDate()}
        onDateChange={() => setCalendarOpen(false)}
      />
      <p>{dayjs(values.date).format('DD/MM/YYYY')}</p>
    </Form>
  )}
</Formik>`,
      scope: { Calendar, Formik, Form, dayjs }
    },
    {
      title: 'Modal',
      code: `<ModalContainer isOpen={true} />`,
      scope: { ModalContainer, Button }
    }
  ]
}

const CalendarStyleGuide = (props: StyleGuideIdProps) => (
  <StyleGuideMain {...props} {...PROPS} />
)

export default CalendarStyleGuide
